import { type GameParticipantId, type DecoratedGameParticipant } from '@terros/common'

export type ParticipantMap = Map<GameParticipantId, DecoratedGameParticipant>

export const buildParticipantMap = (participants: DecoratedGameParticipant[]): ParticipantMap => {
  const map = new Map<GameParticipantId, DecoratedGameParticipant>()
  participants.forEach((p) => {
    map.set(p.participantId, p)
  })
  return map
}

export const getParticipant = (
  participantMap: ParticipantMap,
  participantId: GameParticipantId | undefined
): DecoratedGameParticipant | undefined => {
  if (!participantId) return
  return participantMap.get(participantId)
}
